import { ReactNode } from "react";
import { Paper, Text } from "@mantine/core";

export interface StatCardProps {
    value: ReactNode;
    label: ReactNode;
    valueColor?: string;
    tag?: string;
}

// A single stat tile: a large number on top, a muted label below (with an optional
// small uppercase tag, e.g. a locale). Used in rows for overview / outcome.
export const StatCard = ({ value, label, valueColor = "#0F1B3D", tag }: StatCardProps) => (
    <Paper withBorder radius={16} p={24} style={{ height: "100%" }}>
        <Text
            weight="bold"
            size={40}
            color={valueColor}
            style={{ lineHeight: 1.05, fontVariantNumeric: "tabular-nums" }}
        >
            {value}
        </Text>
        <Text mt={12} size="sm" color="dimmed">
            {label}
            {tag && (
                <Text
                    span
                    size="xs"
                    color="dimmed"
                    ml={6}
                    style={{ textTransform: "uppercase", letterSpacing: "0.04em" }}
                >
                    {tag}
                </Text>
            )}
        </Text>
    </Paper>
);
